import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const browserless = defineConnector({
  identifier: "browserless",
  name: "Browserless",
  tagLine: "Headless browser APIs",
  logo,
  protocol: "http",
  tags: ["engineering", "data"],
  defaultUrlPattern: ({ baseUrl }) =>
    urlToPattern(baseUrl, "https://[^/]*browserless\\.io/.*"),
  auth: (app) => queryAuth([{ name: "token", value: app.secret.apiToken }]),
  steps: [
    {
      title: "Create or copy an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Browserless dashboard](https://www.browserless.io/) and copy an API token. Browserless REST APIs authenticate with the `token` query parameter.",
        },
      ],
    },
    {
      title: "Enter your Browserless details",
      items: [
        {
          kind: "baseUrl",
          label: "Base URL",
          required: true,
          defaultValue: "https://production-sfo.browserless.io",
          placeholder: "https://production-sfo.browserless.io",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "Use your regional or self-hosted Browserless base URL.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url: `${baseUrl || "https://production-sfo.browserless.io"}/content`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url: "https://example.com/" }),
    }),
  },
});
